import { render } from "./Launch.vue?vue&type=template&id=3a4ce132&scoped=true"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"

import "./Launch.vue?vue&type=style&index=0&id=3a4ce132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4ce132"]])

export default __exports__